import { CHAIN_USDC_ADDRESSES } from "../../tokens.js";
import { CORE_PINNED_BLOCK_HASHES, CORE_PINNED_BLOCK_HEIGHTS, CORE_PINNED_TRANSACTION_HASHES } from "../pinned.js";
import { DEAD_ADDRESS, TRANSFER_TOPIC, VITALIK } from "../../integration.js";
import { ERC20_BALANCE_OF_REFERENCE_CALLDATA } from "../fixture-inputs.js";
export const AVALANCHE_TEST_CONFIG = {
    balance: { address: VITALIK },
    balanceQuery: {
        address: VITALIK,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.avalanche,
        fixture: "getBalanceAvalanche",
    },
    tokenBalance: {
        address: VITALIK,
        token: CHAIN_USDC_ADDRESSES.avalanche,
    },
    tokenBalanceQuery: {
        address: VITALIK,
        token: CHAIN_USDC_ADDRESSES.avalanche,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.avalanche,
        fixture: "getTokenBalanceAvalanche",
    },
    blockQuery: {
        block: CORE_PINNED_BLOCK_HEIGHTS.avalanche,
        fixture: "getBlockByNumberAvalanche",
    },
    blockHashQuery: {
        hash: CORE_PINNED_BLOCK_HASHES.avalanche,
        fixture: "getBlockByHashAvalanche",
    },
    blockTransactionsQuery: {
        blockNumber: CORE_PINNED_BLOCK_HEIGHTS.avalanche,
        fixture: "getBlockTransactionsAvalanche",
    },
    transfersQuery: {
        address: VITALIK,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.avalanche,
        fixture: "getTransfersAvalanche",
    },
    receiptQuery: {
        hash: CORE_PINNED_TRANSACTION_HASHES.avalanche,
        fixture: "getReceiptAvalanche",
    },
    transactionByHashQuery: {
        hash: CORE_PINNED_TRANSACTION_HASHES.avalanche,
        fixture: "getTransactionByHashAvalanche",
    },
    estimateGasQuery: {
        to: VITALIK,
        fixture: "estimateGasAvalanche",
    },
    codeQuery: {
        address: CHAIN_USDC_ADDRESSES.avalanche,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.avalanche,
        fixture: "getCodeAvalanche",
    },
    logsQuery: {
        address: CHAIN_USDC_ADDRESSES.avalanche,
        topic0: TRANSFER_TOPIC,
        fromBlock: String(CORE_PINNED_BLOCK_HEIGHTS.avalanche - 50),
        toBlock: String(CORE_PINNED_BLOCK_HEIGHTS.avalanche),
        fixture: "getLogsAvalanche",
    },
    simulateCallQuery: {
        to: CHAIN_USDC_ADDRESSES.avalanche,
        data: ERC20_BALANCE_OF_REFERENCE_CALLDATA,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.avalanche,
        fixture: "simulateCallAvalanche",
    },
    traceTransactionQuery: {
        hash: CORE_PINNED_TRANSACTION_HASHES.avalanche,
        fixture: "traceTransactionAvalanche",
    },
    tokenMetadataQuery: {
        address: CHAIN_USDC_ADDRESSES.avalanche,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.avalanche,
        fixture: "getTokenMetadataAvalanche",
    },
    tokenAllowanceQuery: {
        token: CHAIN_USDC_ADDRESSES.avalanche,
        owner: VITALIK,
        spender: DEAD_ADDRESS,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.avalanche,
        fixture: "getTokenAllowanceAvalanche",
    },
};
